import React from "react";
import Icon from "./Icon";
import "./certification.css";

const levelConfig = {
  NONE: {
    label: "Not Certified",
    color: "#9CA3AF",
    icon: "slash-circle",
    gradient: "#9CA3AF",
    description: "No certification available",
  },
  VERIFIED: {
    label: "Verified",
    color: "#F97316",
    icon: "check-circle",
    gradient: "linear-gradient(135deg, #F97316, #EA580C)",
    description: "Verified certification",
  },
  TRUSTED: {
    label: "Trusted",
    color: "#06B6D4",
    icon: "shield-check",
    gradient: "linear-gradient(135deg, #06B6D4, #0891B2)",
    description: "Trusted level with strong evidence",
  },
  IMPACT: {
    label: "Impact",
    color: "#FFEB3B",
    icon: "star",
    gradient: "linear-gradient(135deg, #FFEB3B, #F9A825)",
    description: "Significant ESG impact",
  },
  REGEN: {
    label: "Regenerative",
    color: "#84CC16",
    icon: "sparkles",
    gradient: "linear-gradient(135deg, #84CC16, #65A30D)",
    description: "Certified regenerative practices",
  },
};

const sizeMap = {
  small: 40,
  medium: 60,
  large: 80,
};

const LevelBadge = ({ level, size = "medium", showLabel = true }) => {
  const config = levelConfig[level] || levelConfig.NONE;
  const dimension = sizeMap[size] || sizeMap.medium;
  const isRegen = level === "REGEN";

  return (
      <div className="cert-level-badge" aria-label={`Level ${config.label}`}>
      <div
        className={`cert-level-badge__circle ${isRegen ? "cert-level-badge__glow" : ""}`}
        style={{
          width: dimension,
          height: dimension,
          background: config.gradient,
          color: level === "NONE" ? "#ffffff" : "#1f2937",
        }}
        title={config.description}
      >
        <Icon name={config.icon} size={dimension * 0.55} color={level === "NONE" ? "#ffffff" : "#111827"} />
      </div>
      {showLabel && <span className="cert-level-badge__label">{config.label}</span>}
    </div>
  );
};

export default LevelBadge;
